import React, { useContext, useEffect, useRef, useState } from "react";
import * as THREE from "three";
import './TextHoverEffect.css';
import { Helmet } from 'react-helmet';
import styled, { css } from 'styled-components';
import { createNoise3D } from "simplex-noise";
import "./Home.css";
import img10 from '../components/assets/sai.jpg';
import img11 from '../components/assets/harshaprofile.jpg';
import img8 from '../components/assets/plus.png';
import profile from '../components/assets/madhu.jpg';
import arrow from '../components/assets/arrowhome.png';
import Abouthome from "../components/abouthome";
import Services from "../components/services";
import Project from "../components/project";
import Projectgalle from "../components/projectgalle";
import Horizontalscrollgasp from "../components/horizontalscrollgasp";
import Testimonials from "../components/Testimonials";
import Contact from "../components/contact";
import Srolltext from "../components/Srolltext";
import {
    motion,
} from "framer-motion"
import RefsContext from "../Refcontex";

const WavyBackgroundContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 100vh;
  background-color: #000;
`;

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Container = styled.div`
  position: absolute;
  top: 70%;
  width: 100%;
  height: 15vh;
  align-items: center;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  perspective: 1000px;

  @media (max-width: 1200px) {
    top: 65%;
    height: auto;
    align-items: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const CardWrapper = styled(motion.div)`
  width: 18.75%;
  height: 14vh;
  background: transparent;
  display: flex;
  flex-direction: column;
  font-family: "Poppins", sans-serif;
  letter-spacing: 3px;
  font-weight: 100;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s;
  transform-style: preserve-3d;
  border-radius: 7vh;
  background:  ${({ backgroundColor }) => backgroundColor};
  ${(props) =>
        props.isHovered &&
        css`
      transform: rotateY(5deg) rotateX(5deg);
    `}
 @media (max-width: 1200px) {
    height: 8vh;
  }
`;

const CardWrapper1 = styled(motion.div)`
  height: 14vh;
  background: #FFCF96;
  display: flex;
  flex-direction: column;
  border: 1px solid  #000000 ;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  border-radius: 7vh;
 @media (max-width: 1200px) {
    height: auto;
  }
`;

const Text = styled.div`
    font-size: 1.2vw;
    line-height: 1.1;
    font-family: "Darker Grotesque", sans-serif;
    letter-spacing: 2px;
    font-weight: 600;
  margin-top: 10px;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  transition: transform 0.5s;
@media (min-width: 768px) and (max-width: 1200px) {
        font-size: 2.3vw;
        font-weight: 600;
    }
    @media (max-width: 767px) {
        font-size: 3.2vw;
        font-weight: 600;
    }
`;

const Stylednew = styled.span`
    display: inline;
    -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile = styled.div`
    width: 10.5vw;
    height: 3vw;
  overflow: hidden;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  display: flex;
  @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile2 = styled(motion.div)`
 display: none;
   -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (max-width: 1200px) {
       width: 26vw;
  height: 8vw;
  overflow: hidden;
  display: flex;
    }
`;

const Stylednew1 = styled.span`
    display: inline;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const StyledImage = styled.img`
  height: 3.5vh;
  margin-bottom: 1.5vh;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  @media (max-width: 1200px) {
     display: none;
  }
`;

const StyledDiv = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
   margin-bottom: 1vw;

`;

const StyledDiv1 = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
`;

const Why = styled.div`
  font-size: 4.2vw;
  color: #fff;
  font-weight: 600;
  letter-spacing: 1px;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  font-family: "Darker Grotesque", sans-serif;
  line-height: 1;

   @media (min-width: 768px) and (max-width: 1200px) {
      font-size:  clamp(9vw, 6vw, 8vw);
    }
    @media (max-width: 767px) {
    font-size:  clamp(9vw, 6vw, 8vw);
    }
`;

const Teamdiv = styled.div`
  width: 3vw;
  height: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  border-radius: 3vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
    }
`;

const Teamdiv1 = styled.div`
  width: 3vw;
  height: 3vw;
  border-radius: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  margin-left: -0.5vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
        margin-left: -2vw;
    }
`;

const VideoHoverEffect = () => {
  const [hiddenClass, setHiddenClass] = useState('');
  const [hiddenClassmobile, setHiddenClassmobile] = useState('');
  const { aboutRef, servicesRef, projectRef } = useContext(RefsContext);

  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
      const handleResize = () => {
          if (window.innerWidth < 1200) {
              setHiddenClass('hidden');
          } else {
              setHiddenClass('');
          }
      };

      window.addEventListener('resize', handleResize);
      handleResize(); // Initial check

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  useEffect(() => {
      const handleResizemobile = () => {
          if (window.innerWidth < 480) {
              setHiddenClassmobile('hidden');
          } else {
              setHiddenClassmobile('');
          }
      };

      window.addEventListener('resize', handleResizemobile);
      handleResizemobile(); // Initial check

      return () => {
          window.removeEventListener('resize', handleResizemobile);
      };
  }, []);

    const videoContainerRef = useRef(null);
    let easeFactor = 0.02;
    let scene, camera, renderer, planeMesh;
    let mousePosition = { x: 0.5, y: 0.5 };
    let targetMousePosition = { x: 0.5, y: 0.5 };
    let prevPosition = { x: 0.5, y: 0.5 };

    const vertexShader = `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `;

    const fragmentShader = `
      varying vec2 vUv;
      uniform sampler2D u_texture;
      uniform vec2 u_mouse;
      uniform vec2 u_prevMouse;

      void main() {
        vec2 gridUV = floor(vUv * vec2(40.0, 40.0)) / vec2(40.0, 40.0);
        vec2 centerOfPixel = gridUV + vec2(1.0/40.0, 1.0/40.0);

        vec2 mouseDirection = u_mouse - u_prevMouse;

        vec2 pixelToMouseDirection = centerOfPixel - u_mouse;
        float pixelDistanceToMouse = length(pixelToMouseDirection);
        float strength = smoothstep(0.3, 0.0, pixelDistanceToMouse);

        vec2 uvOffset = strength * -mouseDirection * 0.4;
        vec2 uv = vUv - uvOffset;

        vec4 color = texture2D(u_texture, uv);
        gl_FragColor = color;
      }
    `;

    const initializeScene = (texture) => {
      scene = new THREE.Scene();

      const aspectRatio = window.innerWidth / window.innerHeight;
      camera = new THREE.OrthographicCamera(
        -aspectRatio,
        aspectRatio,
        1,
        -1,
        0.1,
        1000
      );
      camera.position.z = 1;

      let shaderUniforms = {
        u_mouse: { type: "v2", value: new THREE.Vector2() },
        u_prevMouse: { type: "v2", value: new THREE.Vector2() },
        u_texture: { type: "t", value: texture },
      };

      planeMesh = new THREE.Mesh(
        new THREE.PlaneGeometry(2 * aspectRatio, 2),
        new THREE.ShaderMaterial({
          uniforms: shaderUniforms,
          vertexShader,
          fragmentShader,
        })
      );

      scene.add(planeMesh);

      renderer = new THREE.WebGLRenderer({ antialias: true });
      renderer.setClearColor(0xffffff, 1);
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setPixelRatio(window.devicePixelRatio);

      videoContainerRef.current.appendChild(renderer.domElement);
    };

    const loadVideoTexture = () => {
      const video = document.createElement('video');
      video.src =  'https://genzixbackend.s3.ap-south-1.amazonaws.com/hero4.mp4';
      video.crossOrigin = 'anonymous';
      video.loop = true;
      video.muted = true;
      video.play();

      const videoTexture = new THREE.VideoTexture(video);
      videoTexture.minFilter = THREE.LinearFilter;
      videoTexture.magFilter = THREE.LinearFilter;
      videoTexture.format = THREE.RGBFormat;

      return videoTexture;
    };

    const animateScene = () => {
      requestAnimationFrame(animateScene);

      mousePosition.x += (targetMousePosition.x - mousePosition.x) * easeFactor;
      mousePosition.y += (targetMousePosition.y - mousePosition.y) * easeFactor;

      planeMesh.material.uniforms.u_mouse.value.set(
        mousePosition.x,
        1.0 - mousePosition.y
      );

      planeMesh.material.uniforms.u_prevMouse.value.set(
        prevPosition.x,
        1.0 - prevPosition.y
      );

      renderer.render(scene, camera);
    };

    const handleMouseMove = (event) => {
      easeFactor = 0.035;
      let rect = videoContainerRef.current.getBoundingClientRect();
      prevPosition = { ...targetMousePosition };

      targetMousePosition.x = (event.clientX - rect.left) / rect.width;
      targetMousePosition.y = (event.clientY - rect.top) / rect.height;
    };

    const handleMouseEnter = (event) => {
      easeFactor = 0.01;
      let rect = videoContainerRef.current.getBoundingClientRect();

      mousePosition.x = targetMousePosition.x =
        (event.clientX - rect.left) / rect.width;
      mousePosition.y = targetMousePosition.y =
        (event.clientY - rect.top) / rect.height;
    };

    const handleMouseLeave = () => {
      easeFactor = 0.01;
      targetMousePosition = { ...prevPosition };
    };

    const onWindowResize = () => {
      const aspectRatio = window.innerWidth / window.innerHeight;
      camera.left = -aspectRatio;
      camera.right = aspectRatio;
      camera.top = 1;
      camera.bottom = -1;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);
    };

    useEffect(() => {
      const videoTexture = loadVideoTexture();
      initializeScene(videoTexture);
      animateScene();

      const container = videoContainerRef.current;
      container.addEventListener("mousemove", handleMouseMove);
      container.addEventListener("mouseenter", handleMouseEnter);
      container.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", onWindowResize);

      return () => {
        container.removeEventListener("mousemove", handleMouseMove);
        container.removeEventListener("mouseenter", handleMouseEnter);
        container.removeEventListener("mouseleave", handleMouseLeave);
        window.removeEventListener("resize", onWindowResize);
      };
    }, []);

    return (
        <div style={{ position: 'relative',  height: '100vh' , zIndex:'-2'}}>
          <div ref={videoContainerRef} style={{  height: '100%' }}></div>
          <div style={{position: 'absolute', zIndex: '2', color: 'orange', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <StyledDiv initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut", delay: 9 }} style={{ marginTop: hiddenClass ? (hiddenClassmobile ? '-5vh' : '-13vh') : '-10vh' }}>
                        <Why >Ignite your <Stylednew >digital</Stylednew></Why>
                    </StyledDiv>
                    {hiddenClass ? (
                        <StyledDiv1 initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 9 }}
                            style={{ marginTop: '3vh' }}>
                            <Why >digital presence with us</Why>

                        </StyledDiv1>
                    ) : (
                        <StyledDiv1 initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 9 }}>
                            <Why > presence<span className="space why"></span></Why>
                            <Why><Stylednew1 ></Stylednew1>with us<span className="space "></span></Why>

                        </StyledDiv1>
                    )}
                </div>
        </div>
      );
};

export default VideoHoverEffect;